// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const CveOrgIcon = createSvgIcon(
  <svg viewBox="0 0 320.65 93.91">
    <defs>
      <linearGradient
        id="cve-org_svga"
        x1={152.2}
        x2={152.2}
        y1={90.17}
        y2={5.62}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#f68826" />
        <stop offset={0.45} stopColor="#faa227" />
        <stop offset={1} stopColor="#fdb714" />
      </linearGradient>
    </defs>
    <path
      d="m99.83 88.73 13.75-17.79H56.86a39 39 0 0 1-5.67-.4 34 34 0 0 1-5.31-1.23 31 31 0 0 1-4.8-2 25 25 0 0 1-4.17-2.7 22 22 0 0 1-3.46-3.4 22 22 0 0 1-2.59-4.06 21 21 0 0 1-1.62-4.63 23 23 0 0 1-.54-5 23 23 0 0 1 .56-5.06 20 20 0 0 1 1.68-4.68 23 23 0 0 1 6-7.55 25 25 0 0 1 4.14-2.78 30 30 0 0 1 4.78-2.05 32 32 0 0 1 5.33-1.28 36 36 0 0 1 5.68-.43h41.4v-9h18v-9h9v9h-9v9h9.52l26.61 39.24 1.95 2.88 2-2.84 40.58-57.34h100.92l-13.9 18h-73.61l-.73 1-30.36 42.99-9.7 13.72a23 23 0 0 1-2.89 3.28 36 36 0 0 1-3.65 3 13 13 0 0 1-4 1.89 18 18 0 0 1-5.12.67 19 19 0 0 1-5-.62 13 13 0 0 1-3.92-1.79 24 24 0 0 1-3.48-2.88 26 26 0 0 1-2.93-3.52L99.31 24.72l-.73-1h8.71V5.62H56.86a73 73 0 0 0-10.67.75 60 60 0 0 0-9.76 2.23 53 53 0 0 0-8.66 3.58A44 44 0 0 0 20.46 17a40 40 0 0 0-5.91 5.91 39 39 0 0 0-4.49 7 34 34 0 0 0-2.81 7.82 38 38 0 0 0-.94 8.64A39 39 0 0 0 7.25 55a36 36 0 0 0 2.83 8 41 41 0 0 0 4.5 7.23 41 41 0 0 0 5.92 6.19 46 46 0 0 0 7.33 5.08 56 56 0 0 0 8.66 3.89 57 57 0 0 0 9.74 2.45 66 66 0 0 0 10.63.82h43Zm34.53-83.11v9h9v-9ZM253 39h-39v49.72h70.36l13.74-17.78h-61.6V54.16h44.58L292.94 39Z"
      style={{
        fillRule: "evenodd",
        fill: "url(#cve-org_svga)",
      }}
    />
    <text
      style={{
        fontSize: 18,
        fill: "#ff940e",
        fontFamily: "ArialMT,Arial",
      }}
      transform="translate(303.31 19.09)"
    >
      {"\xAE"}
    </text>
  </svg>,
  "CveOrg",
);
export default CveOrgIcon;
